<template>
  <Teleport to="body">
    <v-snackbar
      v-model="snackbarVisible"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      location="top"
      class="security-tools-snackbar"
      @update:model-value="onSnackbarClose"
    >
      {{ snackbarText }}
    </v-snackbar>
  </Teleport>
</template>

<script>
import { computed } from 'vue';
import { useSnackbarStore } from '@/components/securityTools';

export default {
  name: 'SecurityToolsSnackbar',
  setup() {
    const store = useSnackbarStore();
    return {
      snackbarText: computed(() => store.text),
      snackbarColor: computed(() => store.color || 'red'),
      snackbarTimeout: computed(() => store.timeout ?? 3000),
      snackbarVisible: computed({
        get: () => store.visible,
        set(val) {
          if (!val) store.hideSnackbar();
        },
      }),
      onSnackbarClose() {
        store.hideSnackbar();
      },
    };
  },
};
</script>

<style>
/* Unscoped: snackbar is Teleported to body; ensure it appears above v-bottom-sheet overlay */
.security-tools-snackbar {
  z-index: 2500;
}
</style>
